initGeo();

$(document).ready(function() {
  
  // Sticky Footer
  
  if($(document).height() > $('body').height()){
    console.log("adjust footer");
    var footerAdjust = $(document).height() -$('body').height();
    $("#shopify-section-static-footer").css("bottom", footerAdjust*-1);
  }
  
  
  // Blurry product photo fix
  
  $(".product-gallery--image img:not(.pixelzoom--image)").each(function() {
    var productImgSrc = $(this).attr("src");
    console.log($(this).attr("srcset"));
     $(this).attr("srcset", productImgSrc);
  });
  
  var newHeight = $(".flickity-viewport").closest(".product-gallery--image").height();
  
  $(".flickity-viewport").css("height", newHeight);
  
  
  // PDP Tabs

  $(".pdp-tab").on("mousedown touchstart", function() {

   // console.log("PDP tabs");

    let tabId = $(this).attr("data-pdp-tab");
    let tabContent = $(".product-tabs-content *[data-pdp-tab-content='"+tabId+"']");

    $(".product-tabs-wrapper li").each(function(){
      $(this).removeClass("active");
    });

    $(".product-tabs-content > .rte").each(function(){
      $(this).removeClass("active");
    });

    $(tabContent).addClass("active");

    $(this).addClass("active");

  });
  
  // Collection Image Fix
  
  if ($("body").hasClass("template-collection")){
    $(".productitem--image img").each(function(){
    	let max_photo_height = $(this).width();
    	$(this).css("max-height",max_photo_height);
    });    
  }
  

  
  // CartJS triggers
  
  $("button.js-add-cart").show(0, function(){console.log("cart loaded")});
  
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log("Cart updated: " + cart.item_count);
  });
  

  $('button.js-add-cart').click(function() {
    if(!$("body").hasClass("template-product")){
      //CartJS.addItem($(this).attr("data-variant-id"));
      console.log("add to cart button clicked - " + "Availability: " + $(this).attr("data-availability"));
    }
  });
  
  $('.cart-item--remove-link').click(function() {
    //CartJS.removeItemById($(this).attr("data-variant-id"));
    console.log("Item removed from cart");
  });
  
  $(document).on('change', 'select.js-qty', function(){
    if(!$("body").hasClass("template-product")){
    	var updatedProductID = $(this).attr("data-variant-id");
    	var newQuantity = $(this[this.selectedIndex]).val();
        //CartJS.updateItemById(updatedProductID, newQuantity);
   		console.log("Product quantity updated to: " + newQuantity);
    }
  });
  
  $(document).on('change', 'input.js-qty', function(){
    if(!$("body").hasClass("template-product")){
    	var updatedProductID = $(this).attr("data-variant-id");
    	var newQuantity = $(this).val();
        //CartJS.updateItemById(updatedProductID, newQuantity);
   		console.log("Product quantity updated to: " + newQuantity);
    }
  });
  
  // Header signup
  
  $(".site-header a.small-promo-signup").on('click', function(){
    if(activateGDPR){
      $(".header-signup-form.signup-form-gdpr").show(0, function(){
        $(".header-signup-form.signup-form-gdpr").css('transform','translateY(0)');
        $(".header-signup-wrap").css('height','auto');
        $("#mce-EMAIL").focus();
        //setSiteMainPadding();
      });
    }
    else{
      $(".header-signup-form.signup-form-default").show(0, function(){
        $(".header-signup-form.signup-form-default").css('transform','translateY(0)');
        $(".header-signup-wrap").css('height','auto');
        $("#mce-EMAIL").focus();
        //setSiteMainPadding();
      });  
    }
  });
  
  $(".header-signup-close").on('click', function(){
    $(".header-signup-form").hide();
    $(".header-signup-form").css('transform','translateY(-100%)');
    $(".header-signup-wrap").css('height','0px');
    //setSiteMainPadding();
  });
  
  $(window).scroll(function(){
    if($("body").scrollTop() == 0 && $(".site-main").scrollTop() < $("#shopify-section-static-header").height()){
    	//setSiteMainPadding();
    }
  });
  
  function setSiteMainPadding(){
    var currentHeaderHight = $("#shopify-section-static-header").height();
    $("main.site-main").css('padding-top', currentHeaderHight);
  }
  
  
  $(".site-header-menu-toggle--button").on('click', function(){
    $(".header-signup-form").hide();
    //setSiteMainPadding();
  });
  
  
});

// GDPR
var euCountries = ['AT', 'BE', 'HR', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];
var activateGDPR = false;

function initGeo() {
  var data_country;
  $.ajax({
      url: "https://celestron-freegeoip.herokuapp.com/json/",
      type: "POST",
      dataType: "jsonp",
      success: function(e) {
        data_country = e.country_code;
        gdprCompliance(data_country);
        if(data_country == "US" && $('body').hasClass('template-product')){
          console.log("prop 65");
          caliProp65();
        }
      }
  });
};

function gdprCompliance(ctry_code) {
  console.log("GDRP Check");
  if (euCountries.indexOf(ctry_code) > -1){
    activateGDPR = true;
    //$(".header-signup-form.signup-form-gdpr").show();
    console.log("EU");
  }
  else {
    //$(".header-signup-form.signup-form-default").show();
    console.log("Not EU: " + ctry_code);
  }
}

function caliProp65() {

  var prop65html = '';
  var prop65view = "<a href='#'>View Proposition 65 Warning</a>";
  var prop65img = "<img class='cali-warning' src='https://cdn.shopify.com/s/files/1/1935/4371/files/warning.png?10476927669983959391'>";
  var prop65text = "<p class='cali-warning-text'><strong>WARNING:</strong> Cancer and Reproductive Harm - <a href='http://www.P65Warnings.ca.gov'>www.P65Warnings.ca.gov</a>.</p>";

  prop65html = 
    "<tr class='prop65'>" +
    "<td>California Residents</td>" +
    "<td class='cali-prop65-warning'>" + prop65view + "<span class='prop65-warning-content'>" + prop65img + prop65text + "</span></td>" +
    "</tr>";
  
  console.log("Specs Loaded: " + specsLoaded);
  
  if(!specsLoaded){
    var specCheck = 0;
    var prop65interval = setInterval(function(){
      
      if(specsLoaded){
        console.log("prop 65 text added");
    	$('table.spec-table tbody:last').append(prop65html);
        window.clearInterval(prop65interval);
      }
      
      if(++specCheck === 2){
        console.log("tab restored + prop 65 text added");
        $(".pdp-tab[data-pdp-tab='specs']").show();
        $('.pdp-content-specs').append("<table class='table-open spec-table' id='product-specs-list'>" + prop65html + "</table>");
        window.clearInterval(prop65interval);
      }
      
    }, 500);
  }
  else {
  	console.log("prop 65 text added");
    $('table.spec-table tbody:last').append(prop65html);
    window.clearInterval(prop65interval);
  }
    
}

// Returns

function fixReturnsForm(){

  if ($("div[data-cy='returnPage']").length){
    
    // console.log('fix returns form');
    
    $('h3.rz-ui.rz-header').remove();
    
    $('.rz-container .rz-item.rz-line-item').each(function(){

      // console.log('move returns checkbox');

      let returnItem = $(this);
      
      $(this).css({
        'cssText': 'padding-bottom: 15px !important'
      });

      $(this).find('.rz-field.rz-return-type').prependTo(returnItem);
      
      if(!$(this).find(".rz-disabled-overlay").length){
        // $(this).prepend('<div class="disabled-overlay"></div>');
      }
      
      

    });
    
    

  }
  else {
    
    setTimeout(function() { 
      //console.log('keep checking 2');
      fixReturnsForm();
 	}, 100); 
    
  }
  
}

let customerReturnInfo = {};

if(window.location.pathname.indexOf("returns") > -1){
  
  $(document).on('submit','.rz-container form.rz-ui.rz-form',function(){ 

    console.log('returns form submit test');

    $('.rz-container input').each(function(){
      if($(this).attr('placeholder') == 'Enter email address'){
        customerReturnInfo['return_email'] = $(this).val();
        console.log('Email: ' + $(this).val());
      }
      else {
        customerReturnInfo['return_order'] = $(this).val();
        console.log('Order #: ' + $(this).val());
      }
    });
    
    //fixReturnsForm();
  });
  
  $(document).on('click', "button[data-cy='submit']", function(){
    //console.log('returns submit button');
    //fixReturnsForm();
  });
  
  $(document).on('click', "div.rz-ui.rz-equal.rz-width.rz-grid button[data-cy='back']", function(){
    //console.log('returns back button');
    //fixReturnsForm();
  });
  
  
  $(document).on('click', "form.rz-return-form .rz-return-type > .rz-checkbox", function(){
    $('.rz-checkbox').removeClass('checked');
    $(this).addClass('checked');
    $('h3.rz-ui.rz-header').remove();
    if($(this).hasClass('checked')){
      let disableMessageDiv = $(this).parent().parent().find(".rz-message");
      if($(disableMessageDiv).html().indexOf("Please contact customer support for assistance with this return") != -1){
        $(".rz-return-request-500").parent().remove();
        $(".rz-return-request-500").remove();
      	$(disableMessageDiv).html(
          "<div class='return-request-500'>" +
          "<p>This return requires review by our technical support team. Please click the \"Send Request\" button below to automatically send a return request for this item to our team.</p>" +
          "<label for='returnreason' style='font-weight: bold !important'>Reason for return request:</label>" +
          "<textarea id='returnreason' name='returnreason' maxlength='3000' style='box-sizing: border-box !important; margin-bottom: 15px !important;' required>" +
          "</textarea>"+
          "<button class='btn primary rz-returnRequest' style='color: #fff !important; background-color: #333e48 !important; background: #333e48 !important; border-color: #333e48 !important;'title='Send return request'>Send Request</button>" +
          "</div>"
        );
      }
      
      $(this).parent().parent().find("div[data-cy='returnQuantity']").parent().prepend("<p class='rz-return-qty-notice hidden' style='padding:8px !important;margin:8px 0px !important;border:1px dashed red !important;'>If your are planning to return multiple boxes, please select a quantity of one (1) and create a new return for each item</p>");
    
    }
       
  });
  
  
  $(document).on('click', "form.rz-return-form .rz-return-reason > .checkbox", function(){
    
    $('h3.rz-ui.rz-header').remove();
    
    if($(this).find('input').attr('value') == '65718' || $(this).find('input').attr('value') == '66081') {
      $('.rz-return-qty-notice').removeClass('hidden');
    }
    else {
      $('.rz-return-qty-notice').addClass('hidden');
    }
    
  });
  
  
  $(document).on('click', "button.rz-returnRequest", function(e){
    e.preventDefault();
    let lineItem = $(this).parent().parent().parent().parent().parent().parent().find('.rz-product-title').text();
    let returnJson = customerReturnInfo;
    let returnReason = $('#returnreason').val();
    if(returnReason.length == 0){
      $(this).parent().find('.returnReasonErr').remove();
      $(this).parent().append('<p class="returnReasonErr" style="padding: 10px 0 !important"><strong>Error: Please include a brief reason for your return request.<strong></p>');
    }
    else {
      if(returnReason.length > 3000){
        returnReason = returnReason.substring(0, 2999);
      }
      returnJson['itemName'] = lineItem;
      returnJson['returnReason'] = returnReason;
      console.log("Return item name: " + lineItem);


      let this_message_element = $(this).parent();
      returns_request(returnJson, this_message_element);
    }
    
    

    //$(this).parent().html("<p style='font-weight:600 !important;'>Your request has been submitted. Our team will contact you at your email address: " + customerReturnInfo['return_email'] + '</p>');

    //$(this).parent().html("<p style='font-weight:600 !important;'>There was an error submiting your request. Please contact support at: websupport@celestron.com</p>");
    
  });
  
  
  $(document).on('click', "div.rz-field.rz-return-type .rz-checkbox", function(){
    
    $('h3.rz-ui.rz-header').remove();
    
    console.log('checkbox clicked');
    let thisProduct = $(this).parent().parent().parent().parent().parent();
    
    if($(thisProduct).find('.rz-return-type div.rz-checkbox').hasClass('checked')){
      $('.rz-disabled-overlay').show();
      $(thisProduct).find('.rz-disabled-overlay').hide();
    }
    else {
      $('.rz-disabled-overlay').hide();
    }
    
  });
  
  function returns_request(returnInfo, this_message_element) {

    console.log("Returns request submit");
    
    $.ajax({
      url: "https://cel-returns.herokuapp.com/swreturns.php",
      type: 'POST',
      data: returnInfo, 
      dataType: "json",
      success: function(response) { 
        console.log('AJAX success');
        console.log(response);
        if(response['success'].length > 0){
          console.log(response['success'][0]);
          $(this_message_element).html("<p style='font-weight:600 !important;'>Your request has been submitted. Our team will contact you at your email address: " + customerReturnInfo['return_email'] + '</p>');
        }
        else {
          console.log(response['errors'][0]);
          $(this_message_element).html("<p style='font-weight:600 !important;'>There was an issue submiting your request. Please contact support at: support@skywatcherusa.com</p>");
        }
      },
      error: function(xhr, status, error){
        	 console.log(xhr.responseText);
           var errorMessage = xhr.status + ': ' + xhr.statusText;
           $(this_message_element).html("<p style='font-weight:600 !important;'>We encountered an error while submiting your request. Please contact support at: support@skywatcherusa.com</p><p>" + error + "</p><p>" + errorMessage + "</p>");
           console.log('Error - ' + errorMessage);
        	 console.log(error);console.log(error);
      }
    });
  
  }
  

}

